import { Store } from '@/class/Store';

export type StoreForm = {
  name: string;
  description: string;
  zip: string;
  pref: string;
  city: string;
  address: string;
  building: string;
  latitude: string;
  longitude: string;
  phone_number: string;
  email: string;
  login_id: string;
  open_time: string;
  close_time: string;
  has_parking: boolean;
  weather_code: string;
};

const toTimeInputValue = (value: string | undefined): string => {
  if (!value) {
    return '';
  }

  const match = value.match(/(\d{1,2}):(\d{2})/);
  if (!match) {
    return '';
  }

  return `${match[1].padStart(2, '0')}:${match[2]}`;
};

export const storeToForm = (store: Store): StoreForm => ({
  name: store.name ?? '',
  description: store.description ?? '',
  zip: store.zip ?? '',
  pref: store.pref ?? '',
  city: store.city ?? '',
  address: store.address ?? '',
  building: store.building ?? '',
  latitude: store.latitude != null ? String(store.latitude) : '',
  longitude: store.longitude != null ? String(store.longitude) : '',
  phone_number: store.phone_number ?? '',
  email: store.email ?? '',
  login_id: store.login_id ?? '',
  open_time: toTimeInputValue(store.open_time),
  close_time: toTimeInputValue(store.close_time),
  has_parking: store.has_parking ?? false,
  weather_code: store.weather_code ?? '',
});

export const parseStoreForm = (
  form: StoreForm
): {
  name: string;
  description: string | null;
  zip: string;
  pref: string;
  city: string;
  address: string;
  building: string | null;
  latitude: number;
  longitude: number;
  phone_number: string;
  email: string;
  login_id: string;
  open_time: string;
  close_time: string;
  has_parking: boolean;
  weather_code: string | null;
} | null => {
  if (!form.name.trim()) {
    alert('店舗名を入力してください。');
    return null;
  }
  if (!form.zip.trim()) {
    alert('郵便番号を入力してください。');
    return null;
  }
  if (!form.pref.trim()) {
    alert('都道府県を入力してください。');
    return null;
  }
  if (!form.city.trim()) {
    alert('市区町村を入力してください。');
    return null;
  }
  if (!form.address.trim()) {
    alert('住所を入力してください。');
    return null;
  }
  if (!form.latitude.trim() || Number.isNaN(Number(form.latitude))) {
    alert('緯度を入力してください。');
    return null;
  }
  const latitude = Number(form.latitude);
  if (latitude < -90 || latitude > 90) {
    alert('緯度は -90 から 90 の範囲で入力してください。');
    return null;
  }
  if (!form.longitude.trim() || Number.isNaN(Number(form.longitude))) {
    alert('経度を入力してください。');
    return null;
  }
  const longitude = Number(form.longitude);
  if (longitude < -180 || longitude > 180) {
    alert('経度は -180 から 180 の範囲で入力してください。');
    return null;
  }
  if (!form.phone_number.trim()) {
    alert('電話番号を入力してください。');
    return null;
  }
  if (!form.email.trim()) {
    alert('メールアドレスを入力してください。');
    return null;
  }
  if (!form.login_id.trim()) {
    alert('ログインIDを入力してください。');
    return null;
  }
  if (!form.open_time) {
    alert('開店時間を入力してください。');
    return null;
  }
  if (!form.close_time) {
    alert('閉店時間を入力してください。');
    return null;
  }

  return {
    name: form.name.trim(),
    description: form.description.trim() || null,
    zip: form.zip.trim(),
    pref: form.pref.trim(),
    city: form.city.trim(),
    address: form.address.trim(),
    building: form.building.trim() || null,
    latitude,
    longitude,
    phone_number: form.phone_number.trim(),
    email: form.email.trim(),
    login_id: form.login_id.trim(),
    open_time: form.open_time,
    close_time: form.close_time,
    has_parking: form.has_parking,
    weather_code: form.weather_code.trim() || null,
  };
};
